import { IDevice } from '@pages/Assets/Inventory/types';
import { useCallback } from 'react';
import { IDeviceActionRequestPayload } from '../types';

interface IActionForceReactivation {
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
  actionKey: number;
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
}

const useForceReactivation = ({
  actionKey,
  devicesProps,
  uploadedDevices,
  handleDeviceActions,
}: IActionForceReactivation) => {
  const contentSteps: [] = [];

  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;

    payload.devices =
      devicesProps && devicesProps.length > 0
        ? devicesProps?.map(device => ({
            msisdn: device.msisdn,
          }))
        : uploadedDevices;
    return handleDeviceActions(payload);
  }, [actionKey, devicesProps, uploadedDevices, handleDeviceActions]);

  const forceReactivationData = {
    contentSteps,
    onSubmit,
  };

  return { forceReactivationData };
};

export default useForceReactivation;
